import React, { useState } from 'react'
import 'assets/styles/sigIn.css'
import { useTranslation } from 'react-i18next'

import { Button, Container, Grid, TextField, Typography } from '@material-ui/core'

import { useAuthStore } from 'context/AuthStore'
import { useSignInStyle } from 'pages/SignIn/signIn.styles'
import { LoaderBackdrop } from 'asterX-UI/Loaders'

const INIT_DATA = {
  username: '',
  password: ''
}
const SignIn = () => {
  const classes = useSignInStyle()
  const { authStore, authStoreFunc } = useAuthStore()
  const { t } = useTranslation()
  const [data, setData] = useState(INIT_DATA)

  const handleChange = e => {
    const { name, value } = e.target
    setData(prevState => ({ ...prevState, [name]: value }))
  }

  const signIn = () => authStoreFunc.login(data)
  return (
    <Container maxWidth={'md'} className={classes.rootContainer}>
      <LoaderBackdrop loading={authStore.loading} />
      <Grid
        container
        direction={'column'}
        alignContent={'center'}
        alignItems={'center'}
        justifyContent={'center'}
        spacing={5}
      >
        <Grid item xs={12} md={12} lg={12} xl={12}>
          <Typography variant={'h5'} align={'center'} className={classes.title}>
            {t('sigInPage.Authorization')}
          </Typography>{' '}
        </Grid>
        <Grid item xs={12} md={12} lg={12} xl={12}>
          <TextField
            label={t('username')}
            name={'username'}
            autoComplete="username"
            className={classes.usernameField}
            onChange={handleChange}
          />{' '}
        </Grid>
        <Grid item xs={12} md={12} lg={12} xl={12}>
          <TextField
            label={t('sigInPage.password')}
            id="password"
            name={'password'}
            type="password"
            autoComplete="current-password"
            className={classes.passwordField}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} md={12} lg={12} xl={12}>
          <Button variant={'contained'} color={'primary'} className={classes.signInButton} onClick={signIn}>
            {t('sigInPage.sigIn')}
          </Button>{' '}
        </Grid>
      </Grid>
    </Container>
  )
}

export default SignIn
